import React, { Component } from 'react'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'
import yup from 'yup'

import Button from '@components/Button'
import { inject } from 'mobx-react'
import { Autocomplete } from '@components/Form/Autocomplete'
import Checkbox from '@components/Form/Checkbox'

class NewTeamModal extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    growlStore: PropTypes.object,
    assignEmployee: PropTypes.func,
    teamId: PropTypes.number,
    supervisorId: PropTypes.number,
    employees: PropTypes.object,
    canBeSenior: PropTypes.bool
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: false
  }

  render() {
    return (
      <div>
        <Formik
          initialValues={{
            employeeId: 0,
            isSenior: false
          }}
          enableReinitialize
          validationSchema={yup.object().shape({
            employeeId: yup.number().required('Employee is required'),
            isSenior: yup.boolean().default(false)
          })}
          onSubmit={(values, actions) => {
            this.props
              .assignEmployee({
                teamId: this.props.teamId,
                supervisorId: this.props.supervisorId,
                employeeId: values.employeeId,
                isSenior: values.isSenior
              })
              .then(() => {
                this.props.modalStore.close()
              })
              .catch(error => {
                this.props.growlStore.showError(error)
              })
          }}
          render={form => (
            <div className="expert-form">
              <h1 className="expert-form__title">{'Assign employee'}</h1>
              <Form onSubmit={form.handleSubmit}>
                <div className="expert-form__section">
                  <Field
                    name="employeeId"
                    label="Employee"
                    placeholder="Employee"
                    itemToString={item =>
                      item && `${item.fullName} (${item.position})`
                    }
                    options={this.props.employees}
                    creatable={false}
                    onChange={e => {
                      if (!e) return
                      form.setFieldValue('employeeId', e.id, false)
                    }}
                    valueIsId
                    component={Autocomplete}
                  />
                  {this.props.canBeSenior && (
                    <Checkbox
                      form={form}
                      field="isSenior"
                      onChange={() =>
                        form.setFieldValue(
                          'isSenior',
                          !form.values.isSenior,
                          false
                        )
                      }
                      label="Add as senior team lead"
                    />
                  )}
                </div>
                <div className="expert-form__section">
                  <Button primary submit>
                    Save
                  </Button>
                  <Button secondary onClick={this.props.modalStore.close}>
                    Cancel
                  </Button>
                </div>
              </Form>
            </div>
          )}
        />
      </div>
    )
  }
}

export default inject('modalStore', 'growlStore')(NewTeamModal)
